// Generated by Framer (8f9ffef)
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addFonts, addPropertyControls, ControlType, cx, getFontsFromSharedStyle, getLoadingLazyAtYPosition, Image, Link, RichText, useComponentViewport, useLocaleInfo, useVariantState, withCSS } from "framer";
import { LayoutGroup, motion, MotionConfigContext } from "framer-motion";
import * as React from "react";
import { useRef } from "react";
import * as sharedStyle from "https://framerusercontent.com/modules/jrJYG3qFKtNAE9jV5N1Y/r8X9obsXSeTNDoKaTX8x/cBrvg8Oyy.js";
import * as sharedStyle1 from "https://framerusercontent.com/modules/8pueF4mNT9AKvJSGF8uf/40IqRkRPjERDiMb7UeuJ/cvBBS0X84.js";
import * as sharedStyle3 from "https://framerusercontent.com/modules/dnkWFlGc9jRuGEp6GfId/SwCoBbRhcc1euNwDUWZt/GTISKlX0X.js";
import * as sharedStyle2 from "https://framerusercontent.com/modules/iYkFkOPWOTe9MjZtAIzk/WDD4kjEfsbXUD8eKXkp2/kScfCkJDq.js";
const cycleOrder = ["azE7Y4AM7", "lr5iESJyk", "INLWkWGjB"];
const serializationHash = "framer-qSzTR";
const variantClassNames = {
  azE7Y4AM7: "framer-v-9ruh9l",
  INLWkWGjB: "framer-v-72yq5g",
  lr5iESJyk: "framer-v-9waqnu"
};
function addPropertyOverrides(overrides, ...variants) {
  const nextOverrides = {};
  variants?.forEach(variant => variant && Object.assign(nextOverrides, overrides[variant]));
  return nextOverrides;
}
const transition1 = {
  bounce: 0.2,
  delay: 0,
  duration: 0.4,
  type: "spring"
};
const Transition = ({
  value,
  children
}) => {
  const config = React.useContext(MotionConfigContext);
  const transition = value ?? config.transition;
  const contextValue = React.useMemo(() => ({
    ...config,
    transition
  }), [JSON.stringify(transition)]);
  return /*#__PURE__*/_jsx(MotionConfigContext.Provider, {
    value: contextValue,
    children: children
  });
};
const Variants = motion.create(React.Fragment);
const humanReadableVariantMap = {
  Desktop: "azE7Y4AM7",
  Mobile: "INLWkWGjB",
  Tablet: "lr5iESJyk"
};
const getProps = ({
  height,
  id,
  width,
  ...props
}) => {
  return {
    ...props,
    variant: humanReadableVariantMap[props.variant] ?? props.variant ?? "azE7Y4AM7"
  };
};
const createLayoutDependency = (props, variants) => {
  if (props.layoutDependency) return variants.join("-") + props.layoutDependency;
  return variants.join("-");
};
const Component = /*#__PURE__*/React.forwardRef(function (props, ref) {
  const fallbackRef = useRef(null);
  const refBinding = ref ?? fallbackRef;
  const defaultLayoutId = React.useId();
  const {
    activeLocale,
    setLocale
  } = useLocaleInfo();
  const componentViewport = useComponentViewport();
  const {
    style,
    className,
    layoutId,
    variant,
    ...restProps
  } = getProps(props);
  const {
    baseVariant,
    classNames,
    clearLoadingGesture,
    gestureHandlers,
    gestureVariant,
    isLoading,
    setGestureState,
    setVariant,
    variants
  } = useVariantState({
    cycleOrder,
    defaultVariant: "azE7Y4AM7",
    ref: refBinding,
    variant,
    variantClassNames
  });
  const layoutDependency = createLayoutDependency(props, variants);
  const sharedStyleClassNames = [sharedStyle.className, sharedStyle1.className, sharedStyle2.className, sharedStyle3.className];
  const scopingClassNames = cx(serializationHash, ...sharedStyleClassNames);
  const isDisplayed = () => {
    if (baseVariant === "INLWkWGjB") return false;
    return true;
  };
  const isDisplayed1 = () => {
    if (baseVariant === "INLWkWGjB") return true;
    return false;
  };
  return /*#__PURE__*/_jsx(LayoutGroup, {
    id: layoutId ?? defaultLayoutId,
    children: /*#__PURE__*/_jsx(Variants, {
      animate: variants,
      initial: false,
      children: /*#__PURE__*/_jsx(Transition, {
        value: transition1,
        children: /*#__PURE__*/_jsxs(motion.footer, {
          ...restProps,
          ...gestureHandlers,
          className: cx(scopingClassNames, "framer-9ruh9l", className, classNames),
          "data-border": true,
          "data-framer-name": "Desktop",
          layoutDependency: layoutDependency,
          layoutId: "azE7Y4AM7",
          ref: refBinding,
          style: {
            "--border-bottom-width": "0px",
            "--border-color": "var(--token-0aa53fec-fefb-40a3-a229-e26994a82701, rgba(255, 255, 255, 0.3))",
            "--border-left-width": "1px",
            "--border-right-width": "1px",
            "--border-style": "solid",
            "--border-top-width": "0px",
            ...style
          },
          ...addPropertyOverrides({
            INLWkWGjB: {
              "data-framer-name": "Mobile"
            },
            lr5iESJyk: {
              "data-framer-name": "Tablet"
            }
          }, baseVariant, gestureVariant),
          children: [/*#__PURE__*/_jsxs(motion.div, {
            className: "framer-xxxoqb",
            "data-framer-name": "LeftContent",
            layoutDependency: layoutDependency,
            layoutId: "YEEf9UUo4",
            children: [/*#__PURE__*/_jsxs(motion.div, {
              className: "framer-ea35qj",
              "data-framer-name": "Top",
              layoutDependency: layoutDependency,
              layoutId: "ZXS4qeeQ2",
              children: [/*#__PURE__*/_jsxs(motion.div, {
                className: "framer-1agv68i",
                layoutDependency: layoutDependency,
                layoutId: "ug6YxBOGq",
                children: [/*#__PURE__*/_jsx(Image, {
                  background: {
                    alt: "",
                    fit: "fill",
                    intrinsicHeight: 960,
                    intrinsicWidth: 960,
                    loading: getLoadingLazyAtYPosition((componentViewport?.y || 0) + 48 + 0 + 0 + 0 + 0 + 44),
                    pixelHeight: 1200,
                    pixelWidth: 1200,
                    sizes: "32px",
                    src: globalThis.__COLLABYN_IMAGES__?.["https://framerusercontent.com/images/BBiARPR2zxueAJLEJUALklWW8.png"] ?? "/assets/4d6929cba32b-BBiARPR2zxueAJLEJUALklWW8.png",
                    srcSet: globalThis.__COLLABYN_IMAGES__?.["https://framerusercontent.com/images/BBiARPR2zxueAJLEJUALklWW8.png"] ?? "/assets/98849280ea86-BBiARPR2zxueAJLEJUALklWW8.png 512w,/assets/4d6929cba32b-BBiARPR2zxueAJLEJUALklWW8.png 1024w,/assets/156d8da84da9-BBiARPR2zxueAJLEJUALklWW8.png 1200w"
                  },
                  className: "framer-x9jp7",
                  "data-framer-name": "Collabyn logo final",
                  layoutDependency: layoutDependency,
                  layoutId: "LOgZ0Azx5",
                  ...addPropertyOverrides({
                    INLWkWGjB: {
                      background: {
                        alt: "",
                        fit: "fill",
                        intrinsicHeight: 960,
                        intrinsicWidth: 960,
                        loading: getLoadingLazyAtYPosition((componentViewport?.y || 0) + 24 + 0 + 0 + 0 + 0 + 0 + 44),
                        pixelHeight: 1200,
                        pixelWidth: 1200,
                        sizes: "32px",
                        src: globalThis.__COLLABYN_IMAGES__?.["https://framerusercontent.com/images/BBiARPR2zxueAJLEJUALklWW8.png"] ?? "/assets/4d6929cba32b-BBiARPR2zxueAJLEJUALklWW8.png",
                        srcSet: globalThis.__COLLABYN_IMAGES__?.["https://framerusercontent.com/images/BBiARPR2zxueAJLEJUALklWW8.png"] ?? "/assets/98849280ea86-BBiARPR2zxueAJLEJUALklWW8.png 512w,/assets/4d6929cba32b-BBiARPR2zxueAJLEJUALklWW8.png 1024w,/assets/156d8da84da9-BBiARPR2zxueAJLEJUALklWW8.png 1200w"
                      }
                    }
                  }, baseVariant, gestureVariant)
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      style: {
                        "--font-selector": "R0Y7UGxheWZhaXIgRGlzcGxheS1yZWd1bGFy",
                        "--framer-font-family": '"Playfair Display", "Playfair Display Placeholder", serif',
                        "--framer-font-size": "28px",
                        "--framer-line-height": "24px",
                        "--framer-text-color": "var(--extracted-r6o4lv, rgb(255, 255, 255))"
                      },
                      children: globalThis.__COLLABYN_COPY__?.["Collabyn"] ?? "Collabyn"
                    })
                  }),
                  className: "framer-i7mcvg",
                  "data-framer-name": "Text",
                  fonts: ["GF;Playfair Display-regular"],
                  layoutDependency: layoutDependency,
                  layoutId: "txGEqp6_l",
                  style: {
                    "--extracted-r6o4lv": "rgb(255, 255, 255)",
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                })]
              }), /*#__PURE__*/_jsx(RichText, {
                __fromCanvasComponent: true,
                children: /*#__PURE__*/_jsx(React.Fragment, {
                  children: /*#__PURE__*/_jsx(motion.p, {
                    className: "framer-styles-preset-21bipq",
                    "data-styles-preset": "cBrvg8Oyy",
                    children: globalThis.__COLLABYN_COPY__?.["Simplify Business. Amplify Growth."] ?? "Simplify Business. Amplify Growth."
                  })
                }),
                className: "framer-10gh9cz",
                "data-framer-name": "Text",
                fonts: ["Inter"],
                layoutDependency: layoutDependency,
                layoutId: "o78Xp0fT2",
                style: {
                  "--framer-paragraph-spacing": "0px"
                },
                verticalAlignment: "center",
                withExternalLayout: true
              })]
            }), isDisplayed() && /*#__PURE__*/_jsxs(motion.div, {
              className: "framer-zttlc1",
              "data-framer-name": "Top",
              layoutDependency: layoutDependency,
              layoutId: "hjk7YBf2W",
              children: [/*#__PURE__*/_jsx(RichText, {
                __fromCanvasComponent: true,
                children: /*#__PURE__*/_jsx(React.Fragment, {
                  children: /*#__PURE__*/_jsx(motion.p, {
                    className: "framer-styles-preset-21bipq",
                    "data-styles-preset": "cBrvg8Oyy",
                    children: globalThis.__COLLABYN_COPY__?.["hello@collabyn.com"] ?? "hello@collabyn.com"
                  })
                }),
                className: "framer-1mo31hz",
                "data-framer-name": "Text",
                fonts: ["Inter"],
                layoutDependency: layoutDependency,
                layoutId: "j7QkrArBk",
                style: {
                  "--framer-paragraph-spacing": "0px"
                },
                verticalAlignment: "center",
                withExternalLayout: true
              }), /*#__PURE__*/_jsx(RichText, {
                __fromCanvasComponent: true,
                children: /*#__PURE__*/_jsx(React.Fragment, {
                  children: /*#__PURE__*/_jsx(motion.p, {
                    className: "framer-styles-preset-21bipq",
                    "data-styles-preset": "cBrvg8Oyy",
                    children: globalThis.__COLLABYN_COPY__?.["+91 7799737233"] ?? "+91 7799737233"
                  })
                }),
                className: "framer-1qoehgp",
                "data-framer-name": "Text",
                fonts: ["Inter"],
                layoutDependency: layoutDependency,
                layoutId: "t_PFwGJnw",
                style: {
                  "--framer-paragraph-spacing": "0px"
                },
                verticalAlignment: "center",
                withExternalLayout: true
              }), /*#__PURE__*/_jsx(RichText, {
                __fromCanvasComponent: true,
                children: /*#__PURE__*/_jsx(React.Fragment, {
                  children: /*#__PURE__*/_jsx(motion.p, {
                    className: "framer-styles-preset-21bipq",
                    "data-styles-preset": "cBrvg8Oyy",
                    children: globalThis.__COLLABYN_COPY__?.["Hyderabad, India"] ?? "Hyderabad, India"
                  })
                }),
                className: "framer-v6q699",
                "data-framer-name": "Text",
                fonts: ["Inter"],
                layoutDependency: layoutDependency,
                layoutId: "etFL9gQyp",
                style: {
                  "--framer-paragraph-spacing": "0px"
                },
                verticalAlignment: "center",
                withExternalLayout: true
              }), /*#__PURE__*/_jsx(RichText, {
                __fromCanvasComponent: true,
                children: /*#__PURE__*/_jsx(React.Fragment, {
                  children: /*#__PURE__*/_jsx(motion.p, {
                    className: "framer-styles-preset-21bipq",
                    "data-styles-preset": "cBrvg8Oyy",
                    children: globalThis.__COLLABYN_COPY__?.["Surrey BC, Canada"] ?? "Surrey BC, Canada"
                  })
                }),
                className: "framer-17qrl1i",
                "data-framer-name": "Text",
                fonts: ["Inter"],
                layoutDependency: layoutDependency,
                layoutId: "mxaKZo_ts",
                style: {
                  "--framer-paragraph-spacing": "0px"
                },
                verticalAlignment: "center",
                withExternalLayout: true
              })]
            })]
          }), /*#__PURE__*/_jsxs(motion.div, {
            className: "framer-pukwa6",
            "data-framer-name": "RightNavigation",
            layoutDependency: layoutDependency,
            layoutId: "bKWHFnuj1",
            children: [/*#__PURE__*/_jsxs(motion.div, {
              className: "framer-kk9h28",
              "data-framer-name": "Nav",
              layoutDependency: layoutDependency,
              layoutId: "odfi1Gdwg",
              children: [/*#__PURE__*/_jsx(RichText, {
                __fromCanvasComponent: true,
                children: /*#__PURE__*/_jsx(React.Fragment, {
                  children: /*#__PURE__*/_jsx(motion.p, {
                    className: "framer-styles-preset-16sotju",
                    "data-styles-preset": "cvBBS0X84",
                    children: globalThis.__COLLABYN_COPY__?.["Navigation"] ?? "Navigation"
                  })
                }),
                className: "framer-1ofaxxm",
                "data-framer-name": "Heading 2 → Navigation",
                fonts: ["Inter"],
                layoutDependency: layoutDependency,
                layoutId: "gAj5Dwpdr",
                style: {
                  "--framer-paragraph-spacing": "0px"
                },
                verticalAlignment: "center",
                withExternalLayout: true
              }), /*#__PURE__*/_jsxs(motion.div, {
                className: "framer-464j2d",
                "data-framer-name": "Links",
                layoutDependency: layoutDependency,
                layoutId: "vjuQ2KnO8",
                children: [/*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: {
                          hash: ":wJCoP1HKt",
                          webPageId: "augiA20Il"
                        },
                        motionChild: true,
                        nodeId: "Bts3FybPu",
                        openInNewTab: false,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "VB4yRsb1Z",
                        smoothScroll: true,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["Home"] ?? "Home"
                        })
                      })
                    })
                  }),
                  className: "framer-1lj38db",
                  "data-framer-name": "FAQ",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "Bts3FybPu",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: {
                          hash: ":bS1G9Sni_",
                          webPageId: "augiA20Il"
                        },
                        motionChild: true,
                        nodeId: "lcAXzNwEb",
                        openInNewTab: false,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "VB4yRsb1Z",
                        smoothScroll: true,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["Features"] ?? "Features"
                        })
                      })
                    })
                  }),
                  className: "framer-dmxbec",
                  "data-framer-name": "FAQ",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "lcAXzNwEb",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: {
                          hash: ":YBiNeOYcb",
                          webPageId: "augiA20Il"
                        },
                        motionChild: true,
                        nodeId: "mODlMIfcn",
                        openInNewTab: false,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "VB4yRsb1Z",
                        smoothScroll: true,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["Values"] ?? "Values"
                        })
                      })
                    })
                  }),
                  className: "framer-16ralsf",
                  "data-framer-name": "FAQ",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "mODlMIfcn",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                })]
              })]
            }), /*#__PURE__*/_jsx(motion.div, {
              className: "framer-sgzeb3",
              "data-framer-name": "Nav",
              layoutDependency: layoutDependency,
              layoutId: "RbqbwKipr",
              children: /*#__PURE__*/_jsxs(motion.div, {
                className: "framer-1qjoc41",
                "data-framer-name": "Links",
                layoutDependency: layoutDependency,
                layoutId: "SDdali3r_",
                children: [/*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: "‎ "
                    })
                  }),
                  className: "framer-1pd9yrv",
                  "data-framer-name": "FAQ",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "rybvw23jc",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: {
                          hash: ":ICQeMyiyD",
                          webPageId: "augiA20Il"
                        },
                        motionChild: true,
                        nodeId: "i1kPZ5c4E",
                        openInNewTab: false,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "VB4yRsb1Z",
                        smoothScroll: true,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["Pricing"] ?? "Pricing"
                        })
                      })
                    })
                  }),
                  className: "framer-1bas8wz",
                  "data-framer-name": "FAQ",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "i1kPZ5c4E",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: {
                          hash: ":w0Wr2L5KY",
                          webPageId: "augiA20Il"
                        },
                        motionChild: true,
                        nodeId: "J1PfjytxK",
                        openInNewTab: false,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "VB4yRsb1Z",
                        smoothScroll: true,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["FAQ"] ?? "FAQ"
                        })
                      })
                    })
                  }),
                  className: "framer-fqrad7",
                  "data-framer-name": "404",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "J1PfjytxK",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: {
                          hash: ":BvppAfnk5",
                          webPageId: "augiA20Il"
                        },
                        motionChild: true,
                        nodeId: "nMYgOeA57",
                        openInNewTab: false,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "VB4yRsb1Z",
                        smoothScroll: true,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["Contact Us"] ?? "Contact Us"
                        })
                      })
                    })
                  }),
                  className: "framer-nabk8s",
                  "data-framer-name": "404",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "nMYgOeA57",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true,
                  ...addPropertyOverrides({
                    INLWkWGjB: {
                      children: /*#__PURE__*/_jsx(React.Fragment, {
                        children: /*#__PURE__*/_jsx(motion.p, {
                          className: "framer-styles-preset-zoxxdx",
                          "data-styles-preset": "kScfCkJDq",
                          children: /*#__PURE__*/_jsx(Link, {
                            href: {
                              hash: ":L9zgnjSzF",
                              webPageId: "augiA20Il"
                            },
                            motionChild: true,
                            nodeId: "nMYgOeA57",
                            openInNewTab: false,
                            preserveParams: false,
                            relValues: [],
                            scopeId: "VB4yRsb1Z",
                            smoothScroll: true,
                            children: /*#__PURE__*/_jsx(motion.a, {
                              className: "framer-styles-preset-1dlfqf2",
                              "data-styles-preset": "GTISKlX0X",
                              children: globalThis.__COLLABYN_COPY__?.["Contact Us"] ?? "Contact Us"
                            })
                          })
                        })
                      })
                    }
                  }, baseVariant, gestureVariant)
                })]
              })
            }), /*#__PURE__*/_jsxs(motion.div, {
              className: "framer-15nr9x4",
              "data-framer-name": "Socials",
              layoutDependency: layoutDependency,
              layoutId: "VnM5TcXUM",
              children: [/*#__PURE__*/_jsx(RichText, {
                __fromCanvasComponent: true,
                children: /*#__PURE__*/_jsx(React.Fragment, {
                  children: /*#__PURE__*/_jsx(motion.p, {
                    className: "framer-styles-preset-16sotju",
                    "data-styles-preset": "cvBBS0X84",
                    children: globalThis.__COLLABYN_COPY__?.["Socials"] ?? "Socials"
                  })
                }),
                className: "framer-hf5npo",
                "data-framer-name": "Heading 2 → Navigation",
                fonts: ["Inter"],
                layoutDependency: layoutDependency,
                layoutId: "V_vPUqNHS",
                style: {
                  "--framer-paragraph-spacing": "0px"
                },
                verticalAlignment: "center",
                withExternalLayout: true
              }), /*#__PURE__*/_jsxs(motion.div, {
                className: "framer-5965p1",
                "data-framer-name": "Links",
                layoutDependency: layoutDependency,
                layoutId: "NQC92NRtX",
                children: [/*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: "https://x.com/uxui_arthur",
                        motionChild: true,
                        nodeId: "lMSe3erjs",
                        openInNewTab: true,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "VB4yRsb1Z",
                        smoothScroll: false,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["Twitter (X)"] ?? "Twitter (X)"
                        })
                      })
                    })
                  }),
                  className: "framer-ebqrw1",
                  "data-framer-name": "Templates",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "lMSe3erjs",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsxs(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: [/*#__PURE__*/_jsx(Link, {
                        href: "https://x.com/uxui_arthur",
                        motionChild: true,
                        nodeId: "pCWKS2Hnc",
                        openInNewTab: true,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "VB4yRsb1Z",
                        smoothScroll: false,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: "F"
                        })
                      }), globalThis.__COLLABYN_COPY__?.["acebook"] ?? "acebook"]
                    })
                  }),
                  className: "framer-1mmgt1o",
                  "data-framer-name": "Templates",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "pCWKS2Hnc",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: "https://www.instagram.com/",
                        motionChild: true,
                        nodeId: "ghNdAFJIr",
                        openInNewTab: true,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "VB4yRsb1Z",
                        smoothScroll: false,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["Instagram"] ?? "Instagram"
                        })
                      })
                    })
                  }),
                  className: "framer-mwmu8u",
                  "data-framer-name": "Templates",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "ghNdAFJIr",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: "https://www.linkedin.com/",
                        motionChild: true,
                        nodeId: "C2mGph7IR",
                        openInNewTab: true,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "VB4yRsb1Z",
                        smoothScroll: false,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["LinkedIn"] ?? "LinkedIn"
                        })
                      })
                    })
                  }),
                  className: "framer-1qd4lpq",
                  "data-framer-name": "Templates",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "C2mGph7IR",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                })]
              })]
            }), isDisplayed1() && /*#__PURE__*/_jsxs(motion.div, {
              className: "framer-4l8kzr",
              "data-framer-name": "Contact",
              layoutDependency: layoutDependency,
              layoutId: "cu2g8ocJU",
              children: [/*#__PURE__*/_jsx(RichText, {
                __fromCanvasComponent: true,
                children: /*#__PURE__*/_jsx(React.Fragment, {
                  children: /*#__PURE__*/_jsx(motion.p, {
                    className: "framer-styles-preset-16sotju",
                    "data-styles-preset": "cvBBS0X84",
                    children: "Contact"
                  })
                }),
                className: "framer-169cu27",
                "data-framer-name": "Heading 2 → Navigation",
                fonts: ["Inter"],
                layoutDependency: layoutDependency,
                layoutId: "FfT7acjhT",
                style: {
                  "--framer-paragraph-spacing": "0px"
                },
                verticalAlignment: "center",
                withExternalLayout: true
              }), /*#__PURE__*/_jsxs(motion.div, {
                className: "framer-zxpe5t",
                "data-framer-name": "Links",
                layoutDependency: layoutDependency,
                layoutId: "t_tFB5ge7",
                children: [/*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsxs(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: [/*#__PURE__*/_jsx(Link, {
                        href: "https://x.com/uxui_arthur",
                        motionChild: true,
                        nodeId: "ex6cA8QXI",
                        openInNewTab: true,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "VB4yRsb1Z",
                        smoothScroll: false,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: "h"
                        })
                      }), "ello@collabyn.com"]
                    })
                  }),
                  className: "framer-e5vfpl",
                  "data-framer-name": "Templates",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "ex6cA8QXI",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: globalThis.__COLLABYN_COPY__?.["+91 7799737233"] ?? "+91 7799737233"
                    })
                  }),
                  className: "framer-1on439k",
                  "data-framer-name": "Templates",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "zmMUiJmez",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: globalThis.__COLLABYN_COPY__?.["Hyderabad, India"] ?? "Hyderabad, India"
                    })
                  }),
                  className: "framer-1v97was",
                  "data-framer-name": "Templates",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "VROHGMWnY",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-zoxxdx",
                      "data-styles-preset": "kScfCkJDq",
                      children: globalThis.__COLLABYN_COPY__?.["Surrey BC, Canada"] ?? "Surrey BC, Canada"
                    })
                  }),
                  className: "framer-1o5leoz",
                  "data-framer-name": "Templates",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "hIk80XPCx",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "center",
                  withExternalLayout: true
                })]
              })]
            })]
          })]
        })
      })
    })
  });
});
const css = ["@supports (aspect-ratio: 1) { body { --framer-aspect-ratio-supported: auto; } }", ".framer-qSzTR.framer-1fitjt9, .framer-qSzTR .framer-1fitjt9 { display: block; }", ".framer-qSzTR.framer-9ruh9l { align-content: flex-start; align-items: flex-start; display: flex; flex-direction: row; flex-wrap: nowrap; height: min-content; justify-content: space-between; max-width: 1184px; overflow: visible; padding: 48px; position: relative; width: 1184px; }", ".framer-qSzTR .framer-xxxoqb { align-content: flex-start; align-items: flex-start; align-self: stretch; display: flex; flex: none; flex-direction: column; flex-wrap: nowrap; gap: 40px; height: auto; justify-content: flex-start; overflow: visible; padding: 0px; position: relative; width: 320px; }", ".framer-qSzTR .framer-ea35qj, .framer-qSzTR .framer-zttlc1 { align-content: flex-start; align-items: flex-start; display: flex; flex: none; flex-direction: column; flex-wrap: nowrap; gap: 12px; height: min-content; justify-content: flex-start; overflow: hidden; padding: 0px; position: relative; width: 100%; }", ".framer-qSzTR .framer-1agv68i { align-content: center; align-items: center; display: flex; flex: none; flex-direction: row; flex-wrap: nowrap; gap: 4px; height: min-content; justify-content: center; overflow: visible; padding: 0px; position: relative; width: 100%; }", ".framer-qSzTR .framer-x9jp7 { aspect-ratio: 1 / 1; flex: none; height: var(--framer-aspect-ratio-supported, 32px); overflow: visible; position: relative; width: 32px; }", ".framer-qSzTR .framer-i7mcvg { flex: 1 0 0px; height: auto; position: relative; white-space: pre-wrap; width: 1px; word-break: break-word; word-wrap: break-word; }", ".framer-qSzTR .framer-10gh9cz, .framer-qSzTR .framer-1mo31hz, .framer-qSzTR .framer-1qoehgp, .framer-qSzTR .framer-v6q699, .framer-qSzTR .framer-17qrl1i, .framer-qSzTR .framer-e5vfpl, .framer-qSzTR .framer-1on439k, .framer-qSzTR .framer-1v97was, .framer-qSzTR .framer-1o5leoz { flex: none; height: auto; position: relative; white-space: pre-wrap; width: 100%; word-break: break-word; word-wrap: break-word; }", ".framer-qSzTR .framer-pukwa6 { align-content: flex-start; align-items: flex-start; display: flex; flex: none; flex-direction: row; flex-wrap: nowrap; gap: 64px; height: min-content; justify-content: flex-start; overflow: visible; padding: 0px; position: relative; width: min-content; }", ".framer-qSzTR .framer-kk9h28, .framer-qSzTR .framer-sgzeb3, .framer-qSzTR .framer-15nr9x4, .framer-qSzTR .framer-4l8kzr { align-content: flex-start; align-items: flex-start; display: flex; flex: none; flex-direction: column; flex-wrap: nowrap; gap: 24px; height: min-content; justify-content: flex-start; overflow: hidden; padding: 0px; position: relative; width: 128px; }", ".framer-qSzTR .framer-1ofaxxm, .framer-qSzTR .framer-hf5npo, .framer-qSzTR .framer-169cu27 { flex: none; height: 27px; position: relative; white-space: pre-wrap; width: 100%; word-break: break-word; word-wrap: break-word; }", ".framer-qSzTR .framer-464j2d, .framer-qSzTR .framer-1qjoc41, .framer-qSzTR .framer-5965p1, .framer-qSzTR .framer-zxpe5t { align-content: flex-start; align-items: flex-start; display: flex; flex: none; flex-direction: column; flex-wrap: nowrap; gap: 20px; height: min-content; justify-content: flex-start; overflow: visible; padding: 0px; position: relative; width: 100%; }", ".framer-qSzTR .framer-1lj38db, .framer-qSzTR .framer-dmxbec, .framer-qSzTR .framer-16ralsf, .framer-qSzTR .framer-1pd9yrv, .framer-qSzTR .framer-1bas8wz, .framer-qSzTR .framer-fqrad7, .framer-qSzTR .framer-nabk8s, .framer-qSzTR .framer-ebqrw1, .framer-qSzTR .framer-1mmgt1o, .framer-qSzTR .framer-mwmu8u, .framer-qSzTR .framer-1qd4lpq { flex: none; height: 20px; position: relative; white-space: pre-wrap; width: 100%; word-break: break-word; word-wrap: break-word; }", ".framer-qSzTR.framer-v-9waqnu .framer-pukwa6 { gap: 32px; }", ".framer-qSzTR.framer-v-72yq5g.framer-9ruh9l { flex-direction: column; gap: 48px; justify-content: flex-start; padding: 24px; width: 390px; }", ".framer-qSzTR.framer-v-72yq5g .framer-xxxoqb { align-self: unset; height: min-content; width: 100%; }", ".framer-qSzTR.framer-v-72yq5g .framer-pukwa6 { align-content: unset; align-items: unset; display: grid; gap: 100px 24px; grid-auto-rows: 200px; grid-template-columns: repeat(2, minmax(50px, 1fr)); grid-template-rows: repeat(2, 200px); justify-content: center; padding: 0px 0px 40px 0px; width: 100%; }", ".framer-qSzTR.framer-v-72yq5g .framer-kk9h28, .framer-qSzTR.framer-v-72yq5g .framer-sgzeb3, .framer-qSzTR.framer-v-72yq5g .framer-15nr9x4, .framer-qSzTR.framer-v-72yq5g .framer-4l8kzr { align-self: start; justify-self: start; width: 100%; }", ...sharedStyle.css, ...sharedStyle1.css, ...sharedStyle2.css, ...sharedStyle3.css, '.framer-qSzTR[data-border="true"]::after, .framer-qSzTR [data-border="true"]::after { content: ""; border-width: var(--border-top-width, 0) var(--border-right-width, 0) var(--border-bottom-width, 0) var(--border-left-width, 0); border-color: var(--border-color, none); border-style: var(--border-style, none); width: 100%; height: 100%; position: absolute; box-sizing: border-box; left: 0; top: 0; border-radius: inherit; pointer-events: none; }'];
/**
 * This is a generated Framer component.
 * @framerIntrinsicHeight 336
 * @framerIntrinsicWidth 1184
 * @framerCanvasComponentVariantDetails {"propertyName":"variant","data":{"default":{"layout":["fixed","auto"],"constraints":[null,"1184px",null,null]},"lr5iESJyk":{"layout":["fixed","auto"],"constraints":[null,"1184px",null,null]},"INLWkWGjB":{"layout":["fixed","auto"],"constraints":[null,"1184px",null,null]}}}
 * @framerImmutableVariables true
 * @framerDisplayContentsDiv false
 * @framerAutoSizeImages true
 * @framerComponentViewportWidth true
 * @framerColorSyntax true
 */
const FramerVB4yRsb1Z = withCSS(Component, css, "framer-qSzTR");
export default FramerVB4yRsb1Z;
FramerVB4yRsb1Z.displayName = "Footer";
FramerVB4yRsb1Z.defaultProps = {
  height: 336,
  width: 1184
};
addPropertyControls(FramerVB4yRsb1Z, {
  variant: {
    options: ["azE7Y4AM7", "lr5iESJyk", "INLWkWGjB"],
    optionTitles: ["Desktop", "Tablet", "Mobile"],
    title: "Variant",
    type: ControlType.Enum
  }
});
addFonts(FramerVB4yRsb1Z, [{
  explicitInter: true,
  fonts: [{
    family: "Playfair Display",
    source: "google",
    style: "normal",
    url: "/assets/b036cb91c96e-nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKdFvUDVZNLo_U2r.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    url: "/assets/ba02b29b109b-5vvr9Vy74if2I6bQbJvbw7SY1pQ.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    url: "/assets/d342a0351181-EOr0mi4hNtlgWNn9if640EZzXCo.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+1F00-1FFF",
    url: "/assets/29ec2a1bd449-Y9k9QrlZAqio88Klkmbd8VoMQc.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0370-03FF",
    url: "/assets/2666a469c59b-OYrD2tBIBPvoJXiIHnLoOXnY9M.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    url: "/assets/ca74d6701961-JeYwfuaPfZHQhEG8U5gtPDZ7WQ.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
    url: "/assets/61418a355f78-vQyevYAyHtARFwPqUzQGpnDs.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB",
    url: "/assets/b055aed328b3-b6Y37FthZeALduNqHicBT6FutY.woff2",
    weight: "400"
  }]
}, ...getFontsFromSharedStyle(sharedStyle.fonts), ...getFontsFromSharedStyle(sharedStyle1.fonts), ...getFontsFromSharedStyle(sharedStyle2.fonts), ...getFontsFromSharedStyle(sharedStyle3.fonts)], {
  supportsExplicitInterCodegen: true
});
export const __FramerMetadata__ = {
  exports: {
    Props: {
      type: "tsType",
      annotations: {
        framerContractVersion: "1"
      }
    },
    default: {
      type: "reactComponent",
      name: "FramerVB4yRsb1Z",
      slots: [],
      annotations: {
        framerCanvasComponentVariantDetails: '{"propertyName":"variant","data":{"default":{"layout":["fixed","auto"],"constraints":[null,"1184px",null,null]},"lr5iESJyk":{"layout":["fixed","auto"],"constraints":[null,"1184px",null,null]},"INLWkWGjB":{"layout":["fixed","auto"],"constraints":[null,"1184px",null,null]}}}',
        framerColorSyntax: "true",
        framerIntrinsicWidth: "1184",
        framerComponentViewportWidth: "true",
        framerDisplayContentsDiv: "false",
        framerImmutableVariables: "true",
        framerAutoSizeImages: "true",
        framerIntrinsicHeight: "336",
        framerContractVersion: "1"
      }
    },
    __FramerMetadata__: {
      type: "variable"
    }
  }
};
//# sourceMappingURL=./VB4yRsb1Z.map